import { SESSION_KINDS } from "../../util/constants";
import { post } from "../http/functions";

export const updateSession = async (
  { pk, sk, year, period, calendarType = SESSION_KINDS.FGC, ...body },
) => {
  try {
    const response = await post(`/session/${calendarType}`, {
      ...body,
      pk,
      sk,
      year,
      period,
    });
    const { body: _apiBody } = response?.data || {}
    if(_apiBody?.pk === pk && sk === _apiBody?.sk) {
      return {
        data: _apiBody
      }
    }
    throw new Error(`Unexpected response from update session, mismatched pk and sk.`)
  } catch (error) {
    return error?.error ? error : { error };
  }
};
